import type { IconData } from '@stacksjs/iconify-core'

export const multipleStarsSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.703 3.163c.729-2.217 3.865-2.217 4.594 0l1.619 4.921l4.921 1.619c2.217.729 2.217 3.865 0 4.594l-4.921 1.619l-1.619 4.921c-.729 2.217-3.865 2.217-4.594 0l-1.619-4.921l-4.921-1.619c-2.217-.729-2.217-3.865 0-4.594l4.921-1.619zm19.692 4.222c.827-2.513 4.383-2.513 5.21 0l2.477 7.533l7.533 2.477c2.513.827 2.513 4.383 0 5.21l-7.533 2.477l-2.477 7.533c-.827 2.514-4.383 2.514-5.21 0l-2.477-7.533l-7.533-2.477c-2.514-.827-2.514-4.383 0-5.21l7.533-2.477zm-11 17.848c-.76-2.31-4.03-2.31-4.79 0l-1.824 5.548l-5.548 1.825c-2.31.76-2.31 4.028 0 4.788l5.548 1.825l1.825 5.548c.76 2.31 4.028 2.31 4.788 0l1.825-5.548l5.548-1.825c2.31-.76 2.31-4.028 0-4.788l-5.548-1.825z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default multipleStarsSolid
